import { useState } from 'react'
import { Hidden, Link, Typography } from '@mui/material';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import { Box } from '@mui/system';
import Header from './Header';
import MenuBar from './MenuBar';

const theme = createTheme({
    palette: {
        primary: {
            light:'#48308c',
            main: '#28202c',
            dark: '#180c0c',
        },
    },
    typography: {
      h5: {
        fontWeight: 500,
        fontSize: 26,
        letterSpacing: 0.5,
      },
    },
    shape: {
      borderRadius: 8,
    },
    mixins: {
        toolbar: {
            minHeight: 48,
        },
    },
    components: {
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#18202c',
                    width: 256,
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                contained: {
                    boxShadow: 'none',
                    '&:active': {
                        boxShadow: 'none',
                    },
                },
            },
          },
        MuiTabs: {
            styleOverrides: {
                root: {
                    marginLeft: 1,
                },
                indicator: {
                    height: 3,
                    borderTopLeftRadius: 3,
                    borderTopRightRadius: 3,
                    backgroundColor: 'white',
                },
            }
        },
        MuiTab: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    margin: '0 16px',
                    minWidth: 0,
                    padding: 0,
                },
            }
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    padding: 1,
                },
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    borderRadius: 4,
                },
            }
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    backgroundColor: '#404854',
                },
            }
        },
        MuiListItemText: {
            styleOverrides: {
                primary: {
                    fontWeight: 'medium',
                },
            }
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: 'inherit',
                    marginRight:0,
                    '& svg': {
                        fontSize: 20,
                    },
                },
            }
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    width: 48,
                    height: 48,
                    backgroundColor: '#48308c',
                },
            }
        },
    }
});
  
      
function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
        {'No Rights are Reserved. This is an unsupported release, you are on your own.   '}
        <Link color="inherit" href="http://epensieve.com/about">
            The Pensieve
        </Link>
        {' '}
        {new Date().getFullYear()}
        {'.'}
        </Typography>
    )
}

const Footer = styled('footer')``;

function Layout({children} : any) {
    const [mobileOpen, setMobileOpen] = useState(false);

    return (
        <ThemeProvider theme={theme} >
            <Box sx={{
                display: 'flex',
                minHeight: '100vh'
            }}>
                <Box sx={{
                    [theme.breakpoints.up('sm')]: {
                        width: 256,
                        flexShrink: 0,
                    },
                }}>
                    <Hidden smUp>
                        <MenuBar 
                            variant="temporary"
                            open={mobileOpen}
                            onClose={ () => { setMobileOpen(false); } } 
                        />
                    </Hidden>
                    <Hidden smDown>
                        <MenuBar />
                    </Hidden>
                </Box>
                <Box sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                }} >
                    <Header onDrawerToggle={ () => { setMobileOpen(true); } } />
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        flex: 1,
                        padding: theme.spacing(6, 4),
                        background: '#eaeff1',
                    }}>
                        {children}
                    </Box>
                    <Footer sx={{
                        padding: 2,
                        background: '#eaeff1'
                    }}>
                        <Copyright />
                    </Footer>
                </Box>
            </Box>
        </ThemeProvider>
    );
}

export default Layout;